const getMinAmountDue = (billing) => {
  if (!billing) {
    return undefined;
  }
  if (billing.allowPolicyReinstate === 1) {
    return billing.policyReinstateAmount;
  }
  if (billing.pastDueAmount > 0) {
    return billing.pastDueAmount;
  }
  return billing.currentDueAmount;
};

export default getMinAmountDue;
